/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What the principal identifies.
 */
export const AudienceOptionKind = {
  Everyone: "everyone",
  Role: "role",
  User: "user",
  Agent: "agent",
} as const;
/**
 * What the principal identifies.
 */
export type AudienceOptionKind = OpenEnum<typeof AudienceOptionKind>;

export type AudienceOption = {
  /**
   * Secondary line: email, member count, or attribute key.
   */
  description?: string | undefined;
  /**
   * Human-readable name for the principal.
   */
  displayName: string;
  /**
   * What the principal identifies.
   */
  kind: AudienceOptionKind;
  /**
   * How many people the principal reaches, when known.
   */
  memberCount?: number | undefined;
  /**
   * Canonical principal URN to grant access to.
   */
  principalUrn: string;
};

/** @internal */
export const AudienceOptionKind$inboundSchema: z.ZodMiniType<
  AudienceOptionKind,
  unknown
> = openEnums.inboundSchema(AudienceOptionKind);

/** @internal */
export const AudienceOption$inboundSchema: z.ZodMiniType<
  AudienceOption,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    display_name: z.string(),
    kind: AudienceOptionKind$inboundSchema,
    member_count: z.optional(z.int()),
    principal_urn: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "member_count": "memberCount",
      "principal_urn": "principalUrn",
    });
  }),
);

export function audienceOptionFromJSON(
  jsonString: string,
): SafeParseResult<AudienceOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AudienceOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AudienceOption' from JSON`,
  );
}
